export default "__VITE_ASSET__902ea6cc__"